import React, { RefObject } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { EditButton, DeleteButton } from "@refinedev/mui";
import { TableCell, ModalRef } from "@shared/components";

export const useLevelListColumns = (
  onRefetch: () => void,
  translate: (key: string) => string,
  levelModalRef: RefObject<ModalRef>
): GridColDef[] => {
  return React.useMemo<GridColDef[]>(
    () => [
      {
        field: "id",
        headerName: translate("level_admin.fields.id"),
        width: 80,
      },
      {
        field: "name",
        headerName: translate("level_admin.fields.name"),
        minWidth: 250,
        flex: 1,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="left"
          />
        ),
      },
      {
        field: "rank",
        headerName: translate("level_admin.fields.rank"),
        minWidth: 120,
        headerAlign: "center",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="center"
          />
        ),
      },
      {
        field: "actions",
        headerName: translate("table.actions"),
        headerAlign: "center",
        minWidth: 120,
        sortable: false,
        renderCell: ({ row }) => (
          <TableCell.Container align="center">
            <EditButton
              hideText
              onClick={() => levelModalRef.current?.open(row)}
            />
            {/* <DeleteButton
              hideText
              recordItemId={row.id}
              onSuccess={onRefetch}
            /> */}
          </TableCell.Container>
        ),
      },
    ],
    [translate, onRefetch, levelModalRef]
  );
};
